export var adsDefinition = [{
  id: 'Finect_Content_1',
  path: '/7711056/Finect_Content_1',
  collapseEmptyDiv: false,
  canBeLower: true,
  dimensions: function dimensions() {
    return window.innerWidth >= 800 ? [[728, 90]] : [[300, 150], [300, 100]];
  }
}, {
  id: 'Finect_Content_2',
  path: '/7711056/Finect_Content_2',
  collapseEmptyDiv: false,
  canBeLower: true,
  dimensions: function dimensions() {
    return window.innerWidth >= 800 ? [[728, 90]] : [[300, 150], [300, 100]];
  }
}, {
  id: 'Finect_Home_Grupos',
  path: '/7711056/Finect_Home_Grupos',
  collapseEmptyDiv: true,
  responsive: false,
  canBeLower: false,
  dimensions: function dimensions() {
    return [window.innerWidth <= 640 ? [300, 250] : window.innerWidth <= 800 ? [500, 250] : window.innerWidth <= 1024 ? [300, 250] : window.innerWidth <= 1200 ? [400, 250] : [400, 200]];
  }
}, {
  id: 'Finect_Side1',
  path: '/7711056/Finect_Side1',
  dimensions: [[300, 250]]
}, {
  id: 'Finect_Side2',
  path: '/7711056/Finect_Side2',
  dimensions: [[300, 600]],
  canBeLower: false
}, {
  id: 'Finect_Side3',
  path: '/7711056/Finect_Side3',
  dimensions: [[120, 600], [160, 600], [300, 600]],
  responsive: true,
  higherOnly: true,
  canBeLower: false
}, {
  id: 'Finect_Side4',
  path: '/7711056/Finect_Side4',
  dimensions: [[120, 600], [160, 600], [300, 600]],
  responsive: true,
  higherOnly: true,
  canBeLower: false
}, {
  id: 'Finect_Top1',
  path: '/7711056/Finect_Top1',
  collapseEmptyDiv: false,
  canBeLower: false,
  higherOnly: true,
  responsive: true,
  dimensions: function dimensions() {
    return window.innerWidth >= 800 ? [[728, 90], [970, 250], [970, 90]] : [[300, 150]];
  }
}, {
  id: 'Finect_Comparador_1',
  path: '/7711056/Finect_Comparador_1',
  collapseEmptyDiv: false,
  canBeLower: false,
  higherOnly: true,
  responsive: false,
  dimensions: function dimensions() {
    return window.innerWidth >= 900 ? [[728, 90], [970, 90]] : [[300, 150], [300, 100], [320, 100], [320, 50]];
  }
}, {
  id: 'Finect_Comparador_Side1',
  path: '/7711056/Finect_Comparador_Side1',
  dimensions: [[120, 600], [160, 600], [300, 600]],
  responsive: true,
  higherOnly: true,
  canBeLower: false
}, {
  id: 'Finect_Comparador_Side2',
  path: '/7711056/Finect_Comparador_Side2',
  dimensions: [[120, 600], [160, 600], [300, 600]],
  responsive: true,
  higherOnly: true,
  canBeLower: false
}, {
  id: 'Finect_Patrocinio_Asesores',
  path: '/7711056/Finect_Patrocinio_Asesores',
  collapseEmptyDiv: true,
  canBeLower: false,
  dimensions: function dimensions() {
    return window.innerWidth >= 800 ? [[728, 90], [970, 90]] : [[300, 150]];
  }
}, {
  id: 'BW_Top',
  path: '/7711056/BW_Top',
  dimensions: function dimensions() {
    return [window.innerWidth >= 1200 ? [1126, 90] : [320, 50]];
  }
}, {
  id: 'Finect_Patrocinio_Tag',
  path: '/7711056/Finect_Patrocinio_Tag',
  dimensions: function dimensions() {
    return [window.innerWidth >= 1440 ? [728, 90] : [300, 150]];
  },
  collapseEmptyDiv: true,
  canBeLower: true
}, {
  id: 'Finect_Patrocinio_Tag/Aside',
  path: '/7711056/Finect_Patrocinio_Tag',
  dimensions: [[300, 600], [300, 150]],
  collapseEmptyDiv: true,
  canBeLower: false
}, {
  id: 'Finect_Patrocinio_Home_Productos',
  responsive: true,
  path: '/7711056/Finect_Top',
  dimensions: [[970, 250], [468, 60], [970, 90], [980, 90], [980, 250], [345, 322], [300, 150], [900, 250], [300, 600], [728, 90]],
  collapseEmptyDiv: true,
  canBeLower: false
}];